export class SolarAccountEs {
    public username = "";

    constructor(
        public id: string,
        public lastName: string,
        public firstName: string,
        public phone: string,
        public mobilePhone: string,
        public email: string,
        public emailOperationDate: string,
        public mobilePhoneOperationDate: string,
        public phoneOperationDate: string,
        public documentType: string,
        public documentNumber: string,
        public clientType: string,
        public extraCare: boolean,
        public vip: boolean,
        public language: string,
        public type: string
    ) {
        this.username = `${firstName} ${lastName}`;
    }
}

export class SolarAccountEsFactory {
    static create(account: SolarAccountEs) {
        return new SolarAccountEs(
            account.id,
            account.lastName,
            account.firstName,
            account.phone,
            account.mobilePhone,
            account.email,
            account.emailOperationDate,
            account.mobilePhoneOperationDate,
            account.phoneOperationDate,
            account.documentType,
            account.documentNumber,
            account.clientType,
            account.extraCare,
            account.vip,
            account.language,
            account.type
        );
    }
}

export interface EsSolarContractUser {
    email: string;
    phone: string;
    mobilePhone: string;
}
